export default __webpack_public_path__ + "edafa2dd2adb4b2a5d48dc8e01de8f71.png";